function ActiveStatus() {
    return [
        { ActiveID: "Active", ActiveName: "Active" },
        { ActiveID: "Inactive", ActiveName: "Inactive" }
    ];
  }
  
  export default ActiveStatus;